/**
 * Caches the methods return value in memory to answer subsequent calls immediately
 */
export function Once() {
  const cache = new WeakMap<
    object,
    { value?: unknown; isCached: boolean; isAsync?: boolean }
  >();

  return function (
    _target: any,
    _propertyKey: string,
    descriptor: PropertyDescriptor,
  ) {
    const method = descriptor.value;

    descriptor.value = function (...args: unknown[]): unknown {
      if (!cache.has(this)) {
        cache.set(this, {
          value: undefined,
          isCached: false,
          isAsync: undefined,
        });
      }

      const cached = cache.get(this)!;

      if (!cached.isCached) {
        const returnValue: unknown = method.apply(this, args);
        cached.isAsync = returnValue instanceof Promise;
        cached.value = returnValue;
        cached.isCached = true;
      }

      if (cached.isAsync) {
        return Promise.resolve(cached.value);
      } else {
        return cached.value;
      }
    };

    return descriptor;
  };
}
